/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import root from 'window-or-global';
import { isServer } from '@/utils/isServer';

export const getFingerprint = (): string | undefined => {
  if (isServer) {
    return;
  }

  const bbData = root.IGLOO?.getBlackbox?.();
  if (bbData?.finished) {
    return bbData.blackbox;
  }
};
